import { LeaveApplication, LeaveStatus } from "@/types";

const getUtcDayStartMs = (date: Date): number =>
  Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());

export const hasLeaveEndDatePassed = (
  leaveEndDate: string | Date,
  now: Date = new Date(),
): boolean => {
  const endDate = leaveEndDate instanceof Date
    ? leaveEndDate
    : new Date(leaveEndDate);

  if (Number.isNaN(endDate.getTime())) {
    return false;
  }

  return getUtcDayStartMs(endDate) < getUtcDayStartMs(now);
};

export const canCancelLeave = (
  leave: Pick<LeaveApplication, "status" | "endDate">,
  now: Date = new Date(),
): boolean => {
  if (leave.status === LeaveStatus.PENDING) {
    return true;
  }

  if (leave.status === LeaveStatus.APPROVED) {
    return !hasLeaveEndDatePassed(leave.endDate, now);
  }

  return false;
};
